var globalFunctions = require('./globalFunctions.js');
module.exports = {
  haderHtml: function () {
       let html = '<div class="games-table-header-holder">'+
                    '<div class="games-table-header games-table-title">'+
                        'EVENTS'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>1&2-3</li> '+
                            '<li>2&2-3</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>1&3+</li> '+
                            '<li>2&3+</li>'+
                        '</ul>'+
                    '</div> '+
                    '<div class="games-table-header games-table-two">'+
                        '<ul>'+
                            '<li>1&4+</li> '+
                            '<li>2&4+</li>'+
                        '</ul>'+
                    '</div>'+
                '</div>';

        return html;
  },
  gamesHtml: function (index, quotes) {
    let html =  '<div class="games-table-holder" data-id="'+quotes.ID+'" data-homeTeam="'+quotes.TeamNameHome+'" data-awayTeam="'+quotes.TeamNameAway+'">'+
                    '<div class="games-table games-table-title">'+
                        '<div class="game-number">'+index+'.</div> '+quotes.TeamNameHome+' - '+quotes.TeamNameAway + '<span class="more-games more-games-span" data-modal="' + quotes.ID + '" > + </span>' +
                        '</div> '+
                         '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="1&2-3" data-betCode="500" class="bet-choose" data-odd="'+quotes.WinnerTotalGoals1_23+'">'+globalFunctions.checkQuotes(quotes.WinnerTotalGoals1_23)+'</li> '+
                                '<li data-betType="2&2-3" data-betCode="501" class="bet-choose" data-odd="'+quotes.WinnerTotalGoals2_23+'">'+globalFunctions.checkQuotes(quotes.WinnerTotalGoals2_23)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="1&3+" data-betCode="502" class="bet-choose" data-odd="'+quotes.WinnerTotalGoals1_3Plus+'">'+globalFunctions.checkQuotes(quotes.WinnerTotalGoals1_3Plus)+'</li> '+
                                '<li data-betType="2&3+" data-betCode="503" class="bet-choose" data-odd="'+quotes.WinnerTotalGoals2_3Plus+'">'+globalFunctions.checkQuotes(quotes.WinnerTotalGoals2_3Plus)+'</li>'+
                            '</ul>'+
                        '</div> '+
                        '<div class="games-table games-table-two">'+
                            '<ul>'+
                                '<li data-betType="1&4+" data-betCode="504" class="bet-choose" data-odd="'+quotes.WinnerTotalGoals1_4Plus+'">'+globalFunctions.checkQuotes(quotes.WinnerTotalGoals1_4Plus)+'</li> '+
                                '<li data-betType="2&4+" data-betCode="505" class="bet-choose" data-odd="'+quotes.WinnerTotalGoals2_4Plus+'">'+globalFunctions.checkQuotes(quotes.WinnerTotalGoals2_4Plus)+'</li>'+
                            '</ul>'+
                        '</div>'+
               '</div>';

    return html;
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/odds/final_score_and_total_goals.js
// module id = 2010
// module chunks = 4